export default ".text-anchor {\n  color: #007bff !important;\n}\n\n.text-p {\n  width: 100%;\n}";